module.exports = __webpack_public_path__ + "img/sph-icon.e1555845.png";